import React, { Component } from "react";
import {
  FieldGroup,
  FieldControl,
  FormBuilder,
  Validators
} from "react-reactive-form";
import PropTypes from "proptypes";
import { readableResponseMessage } from "ux-helpers";
import { Auth, API } from "aws-amplify";
import "./FriendsAndSupporters.scss";

export default class FriendsAndSupporters extends Component {
  state = {
    friendsArr: [],
    donorsArr: [],
    toggleFriendSupporter: "friends",
    friendsToggled: true,
    supportersToggled: true
  };

  componentDidMount() {
    // TODO: Only get contacts if the object has changed.
    Auth.currentSession().then(user => {
      this.setState({
        headers: {
          Authorization: user.idToken.jwtToken,
          Token: user.accessToken.jwtToken
        }
      });
      const options = { headers: this.state.headers };
      API.get("give-api", `/user/contacts/${this.props.tripId}`, options)
        .then(response => {
          this.setState({
            friendsArr: response.friends,
            donorsArr: response.donors
          });
        })
        .catch(() => {});
    });
  }

  componentWillUnmount() {
    if (!this.state.friendsToggled) {
      this.setState({
        friendsToggled: true
      });
    }
    if (!this.state.supportersToggled) {
      this.setState({
        supportersToggled: true
      });
    }
  }

  handleSubmitFriends = e => {
    e.preventDefault();
    if (this.friendsAndSupportersForm.status === "VALID") {
      this.setState({ loadingBtn: true });
      this.friendsAndSupportersForm.handleSubmit();
      const { headers } = this.state;
      headers["Content-Type"] = "application/json";
      const options = {
        headers,
        body: [
          {
            ...this.friendsAndSupportersForm.value,
            opportunityId: this.props.tripId
          }
        ]
      };

      API.post("give-api", `/user/contacts/${this.props.tripId}`, options)
        .then(response => {
          if (this.state.toggleFriendSupporter === "friends") {
            this.setState({
              friendsArr: [
                ...this.state.friendsArr,
                {
                  id: response[0].Data.id,
                  ...this.friendsAndSupportersForm.value
                }
              ]
            });
          } else {
            this.setState({
              donorsArr: [
                ...this.state.donorsArr,
                {
                  ...this.friendsAndSupportersForm.value,
                  id: response[0].data.id
                }
              ]
            });
          }
          this.setState({ loadingBtn: false });
          this.friendsAndSupportersForm.controls.firstName.reset();
          this.friendsAndSupportersForm.controls.lastName.reset();
          this.friendsAndSupportersForm.controls.email.reset();
        })
        .catch(error => {
          this.setState({
            loadingBtn: false,
            message: readableResponseMessage(error)
          });
          this.friendsAndSupportersForm.handleSubmit();
        });
      this.friendsAndSupportersForm.submitted = false;
    } else {
      this.friendsAndSupportersForm.handleSubmit();
    }
  };

  handleDelete = id => {
    const { headers } = this.state;
    headers["Content-Type"] = "application/json";
    const options = {
      headers
    };
    API.del("give-api", `/user/contacts/${id}`, options)
      .then(() => {
        if (this.state.toggleFriendSupporter === "friends") {
          const deleteFriendsArray = this.state.friendsArr.filter(
            friend => friend.id !== id
          );
          this.setState({
            friendsArr: deleteFriendsArray
          });
        } else {
          const deleteDonorsArray = this.state.donorsArr.filter(
            donor => donor.id !== id
          );
          this.setState({
            donorsArr: deleteDonorsArray
          });
        }
      })
      .catch(error => {
        this.setState({
          message: readableResponseMessage(error)
        });
      });
  };

  toggleFriendSupportHandler = () => {
    if (this.state.toggleFriendSupporter === "friends") {
      this.setState({ toggleFriendSupporter: "supporters" });
      this.friendsAndSupportersForm.controls.role.setValue("Donor");
    } else {
      this.setState({ toggleFriendSupporter: "friends" });
      this.friendsAndSupportersForm.controls.role.setValue("Friend");
    }
  };

  friendsAndSupportersForm = FormBuilder.group({
    firstName: ["", Validators.required],
    lastName: ["", Validators.required],
    email: ["", [Validators.required, Validators.email]],
    role: ["Friend"]
  });

  render() {
    return (
      <div className="friends-and-supporters" id="invite-friends">
        {this.state.toggleFriendSupporter === "friends" ? (
          <div>
            <h4 className="h1-style muted">
              Invite friends to travel with you!
            </h4>
            <div>
              <p className="margin-top-text">
                We&#39;ll notify them that you&#39;re going!
                {"  "}
                <button
                  className="btn-plain-text"
                  type="button"
                  onClick={this.toggleFriendSupportHandler}
                >
                  Add Supporters!
                </button>
              </p>
            </div>
          </div>
        ) : (
          <div>
            <h4 className="h1-style muted">
              Invite others to support your journey!
            </h4>
            <p className="margin-top-text">
              We&#39;ll notify them about your trip and ways to help you
              fundraise!
              {"  "}
              <button
                className="btn-plain-text inline"
                type="button"
                onClick={this.toggleFriendSupportHandler}
              >
                Invite Friends!
              </button>
            </p>
          </div>
        )}
        <FieldGroup
          control={this.friendsAndSupportersForm}
          render={({ value, submitted }) => (
            <form
              name="Friends & Supporters"
              id="friends-and-supporters-form"
              onSubmit={e => this.handleSubmitFriends(e, value)}
              autoComplete="off"
              style={{ margin: "0px" }}
            >
              <div className="no-padding-col col-sm-12 col-md-12">
                {this.state.message ? (
                  <p
                    className={`center ${
                      this.state.message === "Successfully Updated" ||
                      this.state.message === "Successfully Created"
                        ? "success"
                        : "error"
                    }`}
                  >
                    {this.state.message &&
                    this.friendsAndSupportersForm.status === "INVALID"
                      ? this.state.message
                      : ""}
                  </p>
                ) : (
                  ""
                )}
                <div className="form-sub-title">
                  <FieldControl
                    name="firstName"
                    render={({ handler, touched, hasError, pristine }) => (
                      <div className="inputContainer">
                        <input
                          className="form-control"
                          type="text"
                          {...handler()}
                        />
                        <label
                          htmlFor="firstName"
                          className={`label ${pristine ? "" : "notEmpty"}`}
                        >
                          First Name
                          <span className="error">
                            {(touched || submitted) &&
                              hasError("required") &&
                              " - Required"}
                          </span>
                        </label>
                      </div>
                    )}
                  />

                  <FieldControl
                    name="lastName"
                    render={({ handler, touched, hasError, pristine }) => (
                      <div>
                        <div className="inputContainer">
                          <input
                            className="form-control"
                            type="text"
                            {...handler()}
                          />
                          <label
                            htmlFor="firstName"
                            className={`label ${pristine ? "" : "notEmpty"}`}
                          >
                            Last Name
                            <span className="error">
                              {(touched || submitted) &&
                                hasError("required") &&
                                " - Required"}
                            </span>
                          </label>
                        </div>
                      </div>
                    )}
                  />
                  <FieldControl
                    name="email"
                    render={({ handler, touched, hasError, pristine }) => (
                      <div>
                        <div className="inputContainer">
                          <input
                            className="form-control"
                            type="email"
                            {...handler()}
                          />
                          <label
                            htmlFor="firstName"
                            className={`label ${pristine ? "" : "notEmpty"}`}
                          >
                            Email Address
                            <span className="error">
                              {(touched || submitted) &&
                                hasError("required") &&
                                " - Required"}
                              {touched &&
                                hasError("email") &&
                                " - Not a valid email"}
                            </span>
                          </label>
                        </div>
                      </div>
                    )}
                  />
                  <FieldControl
                    name="role"
                    render={({ handler }) => (
                      <div>
                        <input
                          className="form-control"
                          type="hidden"
                          {...handler()}
                        />
                      </div>
                    )}
                  />
                  <button
                    className={this.state.loadingBtn ? "btn-text-hide" : ""}
                    type="submit"
                    disabled={this.state.loadingBtn}
                  >
                    Submit
                    <span
                      className={`${this.state.loadingBtn ? "loader" : ""}`}
                    />
                  </button>
                </div>
              </div>
            </form>
          )}
        />
        {this.state.friendsArr.length &&
        this.state.toggleFriendSupporter === "friends" ? (
          <div>
            <h3 className="h1-style muted sub-header">
              My Friends{" "}
              <button
                onClick={() => {
                  this.setState(({ friendsToggled }) => ({
                    friendsToggled: !friendsToggled
                  }));
                }}
                className="icon-container list-icon"
              />
            </h3>
            {this.state.friendsToggled ? (
              <ul>
                {this.state.friendsArr.map(friend => (
                  <li key={friend.id} className="friend-list-item">
                    <p className="friend">
                      {" "}
                      {`${friend.firstName} ${friend.lastName}`}
                    </p>
                    <button
                      className="trash-can"
                      onClick={() => this.handleDelete(friend.id)}
                    />
                  </li>
                ))}
              </ul>
            ) : (
              ""
            )}
          </div>
        ) : null}
        {this.state.donorsArr.length &&
        this.state.toggleFriendSupporter === "supporters" ? (
          <div>
            <h3 className="h1-style muted sub-header">
              My Supporters{" "}
              <button
                onClick={() => {
                  this.setState(({ supportersToggled }) => ({
                    supportersToggled: !supportersToggled
                  }));
                }}
                className="icon-container list-icon"
              />
            </h3>
            {this.state.supportersToggled ? (
              <ul>
                {this.state.donorsArr.map(donor => (
                  <li key={donor.id} className="donor-list-item">
                    <p className="donor">
                      {" "}
                      {`${donor.firstName} ${donor.lastName}`}
                    </p>
                    <button
                      className="trash-can"
                      onClick={() => this.handleDelete(donor.id)}
                    />
                  </li>
                ))}
              </ul>
            ) : (
              ""
            )}
          </div>
        ) : null}
      </div>
    );
  }
}

FriendsAndSupporters.propTypes = {
  tripId: PropTypes.string.isRequired
};
